import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { MdDeleteOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { checkAccessFn } from "../../../../../../../../../utils/checkAccess";
import { setAppError } from "../../../../../../../../../store/userSlice";

export default function TableJobDescription({
  titles = ["Sl No.", "Description", "Action"],
  jobRequirements,
  updateJobRequirenments,
  setFormatedJobDescription,
}) {
  const dispatch = useDispatch();
  const [jobDescriptions, setJobDescriptions] = useState(jobRequirements);
  const dashboardData = useSelector((state) => state.dashboardData);
  useEffect(() => {
    setJobDescriptions(jobRequirements);
  }, [jobRequirements]);

  const handleDescriptionChange = (id, value) => {
    const updatedDescription = jobDescriptions.map((data) => {
      if (data?.id == id) {
        return {
          ...data,
          text: value,
        };
      }
      return data;
    });
    setJobDescriptions(updatedDescription);
    setJobDescriptions(updatedDescription);
    updateJobRequirenments(updatedDescription);
  };
  useEffect(() => {
    const JOB_DESCRIPTIONS = jobDescriptions.map((description) => ({
      description,
    }));
    setFormatedJobDescription(JOB_DESCRIPTIONS);
  }, [jobDescriptions]);

  const handleDelete = (id) => {
    if (jobDescriptions.length <= 1) {
      return dispatch(
        setAppError({
          msg: "Atleast one job description is needed",
        })
      );
    }
    const updatedDescription = jobDescriptions.filter((data) => data?.id != id);
    setJobDescriptions(updatedDescription);
    updateJobRequirenments(updatedDescription); //to update the jobdescriptions from parent component
  };

  return (
    <>
      <div className="p-5 oveflow-hidden w-full">
        <div
          className={`grid justify-items-center overflow-auto items-center grid-cols-table-3 auto-cols-min gap-5 p-6 bg-white  w-full   rounded-md `}
        >
          {titles.map((title, index) => (
            <p key={index} className="font-semibold uppercase">
              {title}
            </p>
          ))}
          {jobDescriptions.length <= 0 && (
            <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-3">
              <p>Loading</p>
              <CgSpinner className="animate-spin" />
            </div>
          )}
          {jobDescriptions.map((data, index) => (
            <React.Fragment key={data?.id}>
              <p>{Number(index) + 1}</p>

              <textarea
                rows={2}
                className="textarea textarea-sm textTransformNone textarea-bordered w-full "
                type="text"
                defaultValue={data?.text}
                required
                onChange={(e) =>
                  handleDescriptionChange(data?.id, e.target.value)
                }
                placeholder="Enter Description"
              />

              <div className="flex gap-3 min-w-fit ">
                <button
                  type="button"
                  className="p-1 px-2 rounded-md ring-1 ring-slate-300"
                  onClick={() => handleDelete(data?.id)}
                >
                  <MdDeleteOutline size={"1.4rem"} />
                </button>
              </div>

              <hr className="border-[1.5px] border-slate-100  w-full col-span-3" />
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
}
